import { gql } from '@apollo/client';


export const LAST_UPDATED = gql`
  query LAST_UPDATED($originatorId: ID, $modelName: String){
    lastUpdated(originatorId: $originatorId, modelName: $modelName) 
  }
`;